export default function registerAvailabilityRules(Alpine) {
  Alpine.data("availabilityRules", () => ({
    toggleDay(event) {
      const checkbox = event.currentTarget;
      const day = checkbox.dataset.day;
      const timeInputs = document.querySelector(`.day-time-inputs[data-day="${day}"]`);
      const dayField = document.querySelector(`[data-day-field="${day}"]`);
      const startField = document.querySelector(`[data-start-field="${day}"]`);
      const endField = document.querySelector(`[data-end-field="${day}"]`);

      if (checkbox.checked) {
        if (timeInputs) timeInputs.style.display = "flex";
        if (dayField) dayField.disabled = false;
        if (startField) startField.disabled = false;
        if (endField) endField.disabled = false;
      } else {
        if (timeInputs) timeInputs.style.display = "none";
        if (dayField) dayField.disabled = true;
        if (startField) startField.disabled = true;
        if (endField) endField.disabled = true;
      }
    }
  }));
}
